export const URL_ROOT = "https://flip.id";

export const META_TITLE_DESC = "Solusi Manajemen Transaksi Bisnis Terbaik - Flip for Business";
export const META_DESCRIPTION =
  "Payment gateway untuk transfer antar bank ke banyak tujuan, kirim uang ke luar negeri, terima pembayaran online dengan cepat dan biaya yang terjangkau.";
